import request from '@/utils/request'

let RuleApi = {

  /*规则列表*/
  list(data) {
    return request._post('/shop/plus.rule.Index/index', data);
},
/*添加规则*/
add(data) {
    return request._post('/shop/plus.rule.Index/add', data);
},
/*修改规则*/
edit(data) {
    return request._post('/shop/plus.rule.Index/edit', data);
},
/*删除规则*/
del(data) {
    return request._post('/shop/plus.rule.Index/del', data);
},
/*规则详情*/
detail(data) {
  return request._post('/shop/plus.rule.Index/detail', data);
},
getGrade(data) {
  return request._post('/shop/plus.rule.Index/getGrade', data);
},
}
export default RuleApi;



// WEBPACK FOOTER //
// ./src/api/rule.js